import { render, staticRenderFns } from "./BankExternal.vue?vue&type=template&id=5ade1ba6"
import script from "./BankExternal.vue?vue&type=script&lang=js"
export * from "./BankExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports